module.exports = __webpack_public_path__ + "img/j3oVA_71D1QCXmUIMFc-C.b9faa655.svg";